import axios from "axios";
import api from "@/plugins/api/EntryPoint";

export default {
  async link(payload) {
    try {
      const response = await axios.post(
        process.env.VUE_APP_API_ENDPOINT_URL + "donora/link",
        payload,
        api.getHeaders()
      );

      return response.data;
    } catch (error) {
      console.error("Donora link tracking request failed:", error);
      return false;
    }
  },
};
